import { render, staticRenderFns } from "./OfferStatus.vue?vue&type=template&id=655ef52b&"
import script from "./OfferStatus.vue?vue&type=script&lang=js&"
export * from "./OfferStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports